module.exports = __webpack_public_path__ + "static/dietetyka-image-2-6dd61ad3cb685791f375d63dda7973b2.png";